import React from "react";
import PropTypes from "prop-types";
import { Form } from "react-bootstrap";

/*
NOTE: The values are strings rather than booleans because they come straight off a radio input.
"" means "no filter"; the caller is responsible for converting "true"/"false" into the nullable
boolean the API expects.
*/
export function PayerSetupStatusRadioGroup({
  value,
  onChange,
  name = "PayerSetupStatusFilter",
}) {
  const handleChange = (event) => {
    if (onChange) {
      onChange(event.target.value);
    }
  };

  return (
    <div key={name} className="mb-3 mr-2">
      <Form.Check
        custom="true"
        type="radio"
        id={`${name}-ShowAll`}
        name={name}
        label="Show All"
        value=""
        checked={value === ""}
        onChange={handleChange}
      />
      <Form.Check
        custom="true"
        type="radio"
        id={`${name}-SetupOnly`}
        name={name}
        label="Setup Only"
        value="true"
        checked={value === "true"}
        onChange={handleChange}
      />
      <Form.Check
        custom="true"
        type="radio"
        id={`${name}-NotSetupOnly`}
        name={name}
        label="Not Setup Only"
        value="false"
        checked={value === "false"}
        onChange={handleChange}
      />
    </div>
  );
}

PayerSetupStatusRadioGroup.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  name: PropTypes.string,
};
